// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { chips as _chips } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the chips chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2882
 * Chain Name: Chips Network
 * Default Block Explorer: Not specified
 * Default RPC URL: https://node.chips.ooo/wasp/api/v1/chains/iota1pp3d3mnap3ufmgqnjsnw344sqmf5svjh26y2khnmc89sv6788y3r207a8fn/evm
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { chips } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: chips,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const chips = createCommon({
	..._chips,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
